import { Swiper } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Navigation } from 'swiper/modules';
import { Box } from '@mui/material';

import { useStyles } from './styles';
import { ISwiperWrapperProps } from './interfaces';
import { BREAKPOINTS } from './constants';

const SwiperWrapper = ({
  children,
  horizontalNavigation,
  slidesPerView = 1,
  breakpoints = BREAKPOINTS,
}: ISwiperWrapperProps) => {
  const classes = useStyles();

  return (
    <Box sx={classes.swiperWrap}>
      <Swiper
        slidesPerView={slidesPerView}
        spaceBetween={10}
        pagination={{
          clickable: true,
        }}
        breakpoints={breakpoints}
        modules={[horizontalNavigation ? Navigation : Pagination]}
      >
        {children}
      </Swiper>
    </Box>
  );
};

export default SwiperWrapper;
